import configureStore from './../configureStore/configureStore';
export const store = configureStore();